module.exports = __webpack_public_path__ + "static/img/4.d9ca5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Text/4.png
// module id = 354
// module chunks = 0